/**
 * Algolia Conversion Tracker
 * Sends purchase events to Algolia with revenue data
 */

const AlgoliaConversionTracker = {
  getObjectID: function(product, variant) {
    if (product.metafields && product.metafields.spv_family_id) {
      return product.metafields.spv_family_id;
    }
    if (product.metafields && product.metafields.ean) {
      return product.metafields.ean;
    }
    return variant ? variant.id.toString() : product.id.toString();
  },

  calculateRevenue: function(lineItem) {
    const originalPrice = Number(lineItem.original_price) || 0;
    const totalDiscount = Number(lineItem.total_discount) || 0;
    const finalLinePrice = Number(lineItem.final_line_price) || 0;
    const quantity = Number(lineItem.quantity) || 1;

    const grossRevenue = (originalPrice / 100) * quantity;
    const discount = totalDiscount / 100;
    const netRevenue = finalLinePrice / 100;

    return {
      gross: grossRevenue,
      discount: discount,
      net: netRevenue,
      quantity: quantity
    };
  },

  sendConversion: function(orderData) {
    if (!orderData || !orderData.line_items || orderData.line_items.length === 0) {
      console.warn('[Algolia] No line items in order');
      return;
    }

    if (typeof aa === 'undefined') {
      console.warn('[Algolia] Insights library not loaded');
      return;
    }

    const lineItems = orderData.line_items;
    const searchContext = typeof AlgoliaContextManager !== 'undefined' ? AlgoliaContextManager.getSearchContext() : null;

    const objectIDs = [];
    const objectData = [];

    for (const item of lineItems) {
      const objectID = AlgoliaConversionTracker.getObjectID(item.product, item.variant);
      const revenue = AlgoliaConversionTracker.calculateRevenue(item);

      objectIDs.push(objectID);
      objectData.push({
        price: revenue.gross,
        discount: revenue.discount,
        quantity: revenue.quantity,
        __netRevenue: revenue.net
      });
    }

    const indexName = (searchContext && searchContext.indexName)
      || (typeof globalConfig !== 'undefined' && globalConfig.algoliaIndexName)
      || 'shopify_products';

    const eventData = {
      index: indexName,
      eventName: 'Product Purchased',
      objectIDs: objectIDs,
      objectData: objectData,
      currency: orderData.currency || 'GBP'
    };

    try {
      if (searchContext && searchContext.queryID) {
        eventData.queryID = searchContext.queryID;
        aa('convertedObjectIDsAfterSearch', eventData);
      } else {
        aa('purchasedObjectIDs', eventData);
      }

      if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
          event: 'algolia_conversion',
          algolia: {
            objectIDs: objectIDs,
            totalRevenue: objectData.reduce(function(sum, item) {
              return sum + item.price;
            }, 0),
            hasQueryID: !!(searchContext && searchContext.queryID)
          }
        });
      }
    } catch (error) {
      console.error('[Algolia] Failed to send conversion:', error);
      return;
    }

    if (typeof AlgoliaContextManager !== 'undefined') {
      AlgoliaContextManager.clearContext();
    }
  }
};

if (typeof AlgoliaEvents !== 'undefined') {
  AlgoliaEvents.on(AlgoliaEvents.types.CONVERSION, function(event) {
    const orderData = event.detail;
    AlgoliaConversionTracker.sendConversion(orderData);
  });
}

window.AlgoliaConversionTracker = AlgoliaConversionTracker;
